/**
 * Reports whether a builder canvas (the three-column worksheet/homework
 * crafting view) is on screen. List vs builder is page state on one route, so
 * the shell can't tell from the pathname: App owns the flag and provides its
 * setter here, and useNavRail reads the flag to decide whether collapsing the
 * nav to the icon rail is what lets the picked-items tray dock. The no-op
 * default keeps pages rendering safely when the provider is absent (tests).
 */
import { createContext, useContext, useEffect } from 'react';

export const BuilderCanvasActiveContext = createContext<
  (active: boolean) => void
>(() => undefined);

/**
 * Page-side reporter: marks the builder canvas active while `active` holds.
 * Effect-scoped so flipping back to the list view or unmounting (route
 * change) always releases it.
 */
export const useBuilderCanvasActive = (active: boolean): void => {
  const setActive = useContext(BuilderCanvasActiveContext);
  useEffect(() => {
    if (!active) return undefined;
    setActive(true);
    return () => setActive(false);
  }, [active, setActive]);
};
